module.exports = __webpack_public_path__ + "static/media/stroke_order.82d852fb.png";